import React, { useEffect, useState } from 'react';
import {
  ThemeProvider,
  createTheme,
  CssBaseline,
  Container,
  Typography,
  Box,
  CircularProgress,
  Snackbar,
  Alert,
  Button,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import * as XLSX from 'xlsx';
import axios from 'axios';

const theme = createTheme({
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function Inquiry() {
  const [visitors, setVisitors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  useEffect(() => {
    fetchVisitors();
  }, []);

  const fetchVisitors = async () => {
    try {
      const response = await axios.get('https://puneexpobackend.tdtlworld.com/contact/contact_queries/');
      const formatted = response.data.data.map((item, index) => ({
        id: item.id,
        serial_number: index + 1,
        ...item,
      }));
      setVisitors(formatted);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching visitors:', error);
      setSnackbarMessage('Error fetching visitors. Please try again.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setLoading(false);
    }
  };

  const handleDownloadExcel = () => {
    const exportData = visitors.map((row) => [
      row.serial_number,
      row.name,
      row.email,
      row.contact,
      row.message,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      ['S.No.', 'Name', 'Email', 'Contact', 'Message'],
      ...exportData,
    ]);

    worksheet['!cols'] = [
      { wch: 10 },
      { wch: 25 },
      { wch: 30 },
      { wch: 20 },
      { wch: 40 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Visitors');
    XLSX.writeFile(workbook, 'Inquiry List.xlsx');
  };

  const columns = [
    { field: 'serial_number', headerName: 'S.No.', width: 100 },
    { field: 'name', headerName: 'Name', flex: 1, minWidth: 150 },
    { field: 'email', headerName: 'Email', flex: 1, minWidth: 200 },
    { field: 'contact', headerName: 'Contact', flex: 1, minWidth: 150 },
    { field: 'message', headerName: 'Message', flex: 1, minWidth: 250 },
  ];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Container maxWidth="lg" sx={{ mt: 10, mb: 4 }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', color: '#37474f' }}>
        Inquiry List
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Button variant="contained" color="primary" onClick={handleDownloadExcel}>
            Download Excel
          </Button>
        </Box>

        <Box sx={{ height: 600, width: '100%' }}>
          {loading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <DataGrid
              rows={visitors}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[5, 10, 20]}
              pagination
            />
          )}
        </Box>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackbarSeverity}
            sx={{ width: '100%' }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </ThemeProvider>
  );
}

export default Inquiry;
